export default __webpack_public_path__ + "locales/it/People.json?hash=96997bb789f5b6950a12b3ca9797036c";